import React from 'react';
import { Image, StyleSheet } from '../base_components';

import Link from './link';

const styles = StyleSheet.create({
  linkIcon: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: { width: '100%', height: '100%' },
});

type Props = {
  style?: any;
  imageStyle?: any;
  children?: any;
  resizeMode?: string;
  source: any;
  url: string;
  underlayColor?: any;
};
export default function LinkIcon(props: Props) {
  return (
    <Link style={[styles.linkIcon, props.style]} url={props.url}>
      <Image
        style={[styles.image, props.imageStyle]}
        resizeMode={props.resizeMode || 'contain'}
        source={props.source}
      />
      {props.children}
    </Link>
  );
}
